import { render, staticRenderFns } from "./Bulbs.vue?vue&type=template&id=132c2ec6&scoped=true&"
import script from "./Bulbs.vue?vue&type=script&lang=js&"
export * from "./Bulbs.vue?vue&type=script&lang=js&"
import style0 from "./Bulbs.vue?vue&type=style&index=0&id=132c2ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c2ec6",
  null
  
)

export default component.exports